import { UploadedFontData } from 'editor/src/store/fonts/types';

// The file name and protection are part of the key: the API returns no file hash, so a font of the same name from
// another file, or a protected copy of it, must keep its own row.
const fontKey = (font: UploadedFontData) =>
  [font.name, font.family, font.weight, font.style, font.filename, font.isProtected ? 'protected' : '']
    .map((part) => (part ?? '').toLowerCase())
    .join('|');

/**
 * One row per font: the same file uploaded more than once arrives as separate fonts, which would list it
 * again for every copy. The copy the selected text uses stands for its group, so the active row stays marked.
 */
function dedupeUploadedFonts(fonts: UploadedFontData[], currentFontFile?: string): UploadedFontData[] {
  const byKey = new Map<string, UploadedFontData>();
  fonts.forEach((font) => {
    const key = fontKey(font);
    if (!byKey.has(key) || font.fontFile === currentFontFile) {
      byKey.set(key, font);
    }
  });
  return [...byKey.values()];
}

export default dedupeUploadedFonts;
